import React from 'react';
import DocumentPanel from '../Documents/DocumentPanel';

/**
 * The client's filed documents — the archived rows, kept for the record rather than used on
 * orders. Takes `client_id` as a prop because the admin pages render it for an account other
 * than the signed-in one.
 *
 * Display and data handling now live in Documents/DocumentPanel, shared with CustomDocuments.
 * The signature is unchanged: `isAdmin` picks the heading and drops the card surface, `editable`
 * gates upload and delete, and `allowedTypes` narrows the type dropdown.
 */
const ArchiveDocuments = ({ client_id, isAdmin, editable = true, allowedTypes, bare = false }) => (
    <DocumentPanel
        clientId={client_id}
        archived
        isAdmin={isAdmin}
        editable={editable}
        allowedTypes={allowedTypes}
        bare={bare}
    />
);

export default ArchiveDocuments;
